(function ($) {

	class CheckoutContact {

		$contact_form = null
		$billing_fields = null
		$add_billing_info = null

		constructor() {
			$(document).gp_ready(this.init_form)
		}

		init_form = () => {

			// Init elements
			this.$contact_form = $('form[data-form-id="checkout-contact"]')
			this.$billing_fields = this.$contact_form.find('.billing-address')
			this.$add_billing_info = this.$contact_form.find('input[name="add_billing_info"]')

			// Show/hide billing fields on init
			this.init_billing_info()

			// Bind show/hide billing fields
			this.$add_billing_info.gp_on('change', this.toggle_billing_info)
		}

		init_billing_info = () => {
			if (this.$add_billing_info.is(':checked')) {
				this.$billing_fields.show()
			} else {
				this.$billing_fields.hide()
			}
		}

		toggle_billing_info = () => {
			if (this.$add_billing_info.is(':checked')) {
				this.$billing_fields.slideDown(250)
			} else {
				this.$billing_fields.slideUp(250)
			}
		}

	}

	new CheckoutContact();

})(jQuery)